import moment from "moment";
import { useSelector } from "react-redux";
import { setPageLoader } from "../../Redux/features/utils.slice"
import { postRequest } from "../apiMethods";
import { apiRoutes } from "../apiRoutes"
const { logs } = apiRoutes;

const getDowntimeLogList = async (dispatch, selector) => {

    dispatch(setPageLoader({ page: 'lineOperator', flag: true }))

    let { range } = selector;
    let startDate = range[1] ? moment(range[1]).format(`YYYY-MM-DDThh:mm:ss.ms`) : ""
    let endDate = range[0] ? moment(range[0]).format(`YYYY-MM-DDThh:mm:ss.ms`): ""
    let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))
    let response = await postRequest({
        endPoint: logs.downtimes,
        body: { "conditions": {
            "started": { "$gte": `${startDate}Z`, "$lte": `${endDate}Z` },
            "plantId": plant?._id,
            "lineId": line?.id,
            "machine": machine?.machineName } }
    })
    dispatch(setPageLoader({ page: 'lineOperator', flag: false }))
    // console.log({ response })
}

export { getDowntimeLogList }
